import React, { useEffect } from 'react';

const Modal = ({ isOpen, onClose, title, message, type = 'info' }) => {
  useEffect(() => {
    if (isOpen) {
      // Автоматически закрываем через 3 секунды для успешных сообщений
      if (type === 'success') {
        const timer = setTimeout(() => {
          onClose();
        }, 3000);
        return () => clearTimeout(timer);
      }
    }
  }, [isOpen, onClose, type]);

  if (!isOpen) return null;

  const getModalClass = () => {
    switch (type) {
      case 'success':
        return 'modal-success';
      case 'error':
        return 'modal-error';
      case 'warning':
        return 'modal-warning';
      default:
        return 'modal-info';
    }
  };

  const getIcon = () => {
    switch (type) {
      case 'success':
        return '✓';
      case 'error':
        return '✕';
      case 'warning':
        return '!';
      default:
        return 'ℹ';
    }
  };

  return (
    <>
      <div className="modal-backdrop" onClick={onClose} />
      <div className={`modal ${getModalClass()}`}>
        <div className="modal-header">
          <div className="modal-icon">{getIcon()}</div>
          <h3>{title || (type === 'success' ? 'Success' : type === 'error' ? 'Error' : 'Information')}</h3>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>
        <div className="modal-body">
          <p>{message}</p>
        </div>
        <div className="modal-footer">
          <button className="btn btn-primary" onClick={onClose}>
            OK
          </button>
        </div>
      </div>
    </>
  );
};

export default Modal;